import { render, staticRenderFns } from "./KioskTablePicker.vue?vue&type=template&id=d8c7298c&scoped=true"
import script from "./KioskTablePicker.vue?vue&type=script&lang=js"
export * from "./KioskTablePicker.vue?vue&type=script&lang=js"
import style0 from "./KioskTablePicker.vue?vue&type=style&index=0&id=d8c7298c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c7298c",
  null
  
)

export default component.exports